// extracted by mini-css-extract-plugin
module.exports = {"mobileMessagesHolder":"MobileMessages_mobileMessagesHolder__3QLEY","mobileMessagesHolderNoMessages":"MobileMessages_mobileMessagesHolderNoMessages__2QyQ7"};